import { useTranslation } from "react-i18next";
import vconst from "utils/helpers/structs/vconst";

const ExpendStatBadge = ({expendStatus, fs=12}) => {
    const { t } = useTranslation(['Objects']);
    return (
        <span className={`badge ${vconst.bgRowExpendStat?.[expendStatus]||'bg-light-success'} d-block d-md-inline mb-1 fs-${fs}`}>
        {t(`expendStatus.${expendStatus}`)}
        </span>)
} 

export default ExpendStatBadge;